import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';

interface SpendChartProps {
  data: Array<{ date: string; spend: number }>;
  title?: string;
  color?: string;
}

export function SpendChart({ data, title, color = '#00d4ff' }: SpendChartProps) {
  // Ensure the color can be parsed even if it's a CSS variable
  const fillColor = color.startsWith('var(') ? '#00d4ff' : color;

  return (
    <div className="spend-chart">
      {title && <h3 className="spend-chart__title">{title}</h3>}
      <ResponsiveContainer width="100%" height={240}>
        <AreaChart data={data} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
          <defs>
            <linearGradient id={`grad-${fillColor.replace('#', '')}`} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={fillColor} stopOpacity={0.3} />
              <stop offset="100%" stopColor={fillColor} stopOpacity={0.02} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="var(--border-default)" />
          <XAxis
            dataKey="date"
            tick={{ fill: '#64748b', fontSize: 11 }}
            tickLine={false}
            axisLine={{ stroke: '#1e2d4a' }}
            tickFormatter={(val: string) => {
              const d = new Date(val);
              return `${d.getMonth() + 1}/${d.getDate()}`;
            }}
          />
          <YAxis
            tick={{ fill: '#64748b', fontSize: 11 }}
            tickLine={false}
            axisLine={{ stroke: '#1e2d4a' }}
            tickFormatter={(val: number) => `$${val}`}
          />
          <Tooltip
            contentStyle={{
              background: '#0c1526',
              border: '1px solid #1e2d4a',
              borderRadius: 6,
              fontSize: 12,
            }}
            labelStyle={{ color: '#64748b' }}
            itemStyle={{ color: fillColor }}
            formatter={(value: number | string | undefined) => [`$${Number(value ?? 0).toFixed(2)}`, 'Spend']}
          />
          <Area
            type="monotone"
            dataKey="spend"
            stroke={fillColor}
            strokeWidth={2}
            fill={`url(#grad-${fillColor.replace('#', '')})`}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
